import { mainClient } from '~/network';

const YMID = 73437139;

export const sendYmGoal = (name) => {
    window.ym(YMID, 'reachGoal', name);
};

export const sendGaEvent = (name, params) => {
    window.gtag('event', name, { ...params });
};

export const ym = {
    registr: () => {
        sendYmGoal('registr');
    },
    register: () => {
        console.warn("disabled analytics trigger: window.ym(73437139, 'reachGoal', 'registration');");
        // window.ym(YMID, 'reachGoal', 'registration');
    },
    login: () => {
        console.warn("disabled analytics trigger: window.ym(73437139, 'reachGoal', 'login_send');");
        // window.ym(YMID, 'reachGoal', 'login_send');
    },
    typeAccountStep: () => {
        sendYmGoal('type-account');
        sendGaEvent('type-account');
    },
    personalDataStep: () => {
        sendYmGoal('personal-data');
        sendGaEvent('personal-data');
    },
    financialStatusStep: () => {
        sendYmGoal('financial-status');
        sendGaEvent('financial-status');
    },
    questionnaireStep: () => {
        sendYmGoal('questionnaire');
        sendGaEvent('questionnaire');
    },
    dataVerificationStep: () => {
        sendYmGoal('data-verification');
        sendGaEvent('data-verification');
    },
    confirmationStep: () => {
        sendYmGoal('confirmation');
        sendGaEvent('confirmation');
    },
};

export const gtag = {
    register: () => {
        window.gtag('event', 'send', { 'event_category': 'registration' });
    },
    login: () => {
        window.gtag('event', 'send', { 'event_category': 'login' });
    },
};

export const checkUserData = (userData) => {
    if (!userData.hasAnalytics) {
        console.warn('user analytics is EMPTY');
        fillUserData();
    }
};

export const sendUserId = (id) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'userId',
        'user_id': id,
    });
    window.ga && window.ga('set', 'dimension1', id);
};

export const fillUserData = () => {
    const analytics = [
        {
            cookies: document.cookie.split('; '),
        },
        {
            'user-agent': window.navigator.userAgent,
        },
    ];
    const formData = new FormData();
    formData.append('data', JSON.stringify(analytics));
    mainClient.users.requests.updateUserAnalytics(formData);
};

export default {
    checkUserData,
    fillUserData,
    sendUserId,
    gtag,
    ym,
};
